import { parseISODateYMD, todayISO } from "../lib/date";

export function calcAgeAtDate(birthdayYmd: unknown, onDateYmd: unknown) {
  const b = parseISODateYMD(birthdayYmd);
  const t = parseISODateYMD(onDateYmd);
  if (!b || !t) return null;
  let age = t.getFullYear() - b.getFullYear();
  const md = t.getMonth() - b.getMonth();
  if (md < 0 || (md === 0 && t.getDate() < b.getDate())) age -= 1;
  return age;
}

export function calcAge(birthdayYmd: unknown) {
  return calcAgeAtDate(birthdayYmd, todayISO());
}

// "X" means "prefer not to say" — averages the male/female adjustments.
function sexAdjustment(gender: string): number {
  if (gender === "M") return 5;
  if (gender === "F") return -161;
  return (5 + -161) / 2;
}

export function calcBMRAtDate({ weightLbs, heightIn, gender, birthday, onDateYmd }: { weightLbs: number; heightIn: number; gender: string; birthday: string; onDateYmd: string }) {
  const age = calcAgeAtDate(birthday, onDateYmd);
  if (!weightLbs || !heightIn || !gender || age === null) return null;
  const weightKg = weightLbs * 0.453592;
  const heightCm = heightIn * 2.54;
  const base = 10 * weightKg + 6.25 * heightCm - 5 * age;
  return base + sexAdjustment(gender);
}

export function calcBMR({ weightLbs, heightIn, gender, birthday }: { weightLbs: number; heightIn: number; gender: string; birthday: string }) {
  const age = calcAge(birthday);
  if (!weightLbs || !heightIn || !gender || age === null) return null;
  const weightKg = weightLbs * 0.453592;
  const heightCm = heightIn * 2.54;
  const base = 10 * weightKg + 6.25 * heightCm - 5 * age;
  return base + sexAdjustment(gender);
}

export function calcTDEEFromActive({ bmr, activeCalories }: { bmr: number | null; activeCalories: number | null }) {
  if (bmr === null) return null;
  const active = activeCalories ?? 0;
  return bmr * 1.2 + active;
}

export function calcTDEEFromFactor({ bmr, factor }: { bmr: number | null; factor: number }) {
  if (bmr === null) return null;
  return bmr * factor;
}

export function getNetCalories(calIn: number | null, tdee: number | null) {
  if (calIn === null || tdee === null) return null;
  return calIn - tdee;
}
